import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { RepeatIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';

const StyledButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  background: 'none',
  padding: 0,
  border: 'none',
  fontWeight: 500,
  fontSize: 12,
  color: 'var(--text-text-secondary-color)',
  svg: {
    fill: 'var(--text-text-secondary-color)',
  },
  cursor: 'pointer',
  '&:hover': {
    color: 'var(--text-text-primary-color)',
    svg: {
      fill: 'var(--text-text-primary-color)',
    },
  },
}));

const messageBus = new MessageBus('prototypes');

export type MoveFigmaReportButtonProps = {
  id: string;
};

export const MoveFigmaReportButton = ({ id }: MoveFigmaReportButtonProps) => {
  const { t } = useI18n();

  const onClick = () => {
    messageBus.publish('modal:move-figma-report:open', { id });
  };

  return (
    <StyledButton onClick={onClick}>
      <RepeatIcon />
      {t('shared:transfer')}
    </StyledButton>
  );
};
